/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoYandexZenIcon16Solid = forwardRef('LogoYandexZenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.74 1H4.5A3.5 3.5 0 0 0 1 4.5v3.24c2.629-.08 4.197-.372 5.282-1.458C7.367 5.197 7.66 3.63 7.74 1Z" }),
        React.createElement("path", { d: "M1 8.26v3.24A3.5 3.5 0 0 0 4.5 15h3.24c-.08-2.629-.373-4.197-1.458-5.282C5.197 8.632 3.629 8.339 1 8.26Z" }),
        React.createElement("path", { d: "M8.26 15h3.24a3.5 3.5 0 0 0 3.5-3.5V8.26c-2.63.08-4.197.372-5.282 1.458C8.632 10.803 8.339 12.37 8.26 15Z" }),
        React.createElement("path", { d: "M15 7.74c-2.63-.08-4.197-.372-5.282-1.458C8.632 5.197 8.339 3.63 8.26 1h3.24A3.5 3.5 0 0 1 15 4.5v3.24Z" })));
});
